module.exports = __webpack_public_path__ + "static/Leaf_3_Beer_Animations_1-75adddd833d8b2da4010c60833df7de8.png";